import Damage from "../crew/Damage";
import BigNumSave from "./BigNumSave";

export default class DamageSave {
    constructor() {        
    }

    /**
     * @param {Damage} damage
     * @returns {Object}
     */
    static generateSave(damage) {
        const saveState = {};

        // We probably don't need to save these values. Everything in Damage is calculated or from the settings object.

        saveState.basePick = BigNumSave.save(damage.basePickDamagePerTurn);
        saveState.totalPick = BigNumSave.save(damage.totalPickDamagePerTurn);

        return saveState;
    }

    /**
     * @param {Damage} damage
     * @param {Object} saveState 
     */
    static loadSave(damage, saveState) {
        if (!saveState) {
            return;
        }
        
        BigNumSave.load(saveState.basePick, damage.basePickDamagePerTurn);
        BigNumSave.load(saveState.totalPick, damage.totalPickDamagePerTurn);
    }

}